import axios from "axios";
import {Base64} from "js-base64";
import bundledNewWords from './data/newWords.json';
import bundledWords3500 from './data/words3500.json';

function normalizeWordsData(data, name) {
    let normalized = data;
    if (typeof normalized === 'string') {
        normalized = JSON.parse(normalized);
    }
    if (!normalized || !Array.isArray(normalized.data)) {
        throw new Error(`${name} data is invalid`);
    }
    return normalized;
}

function readWordCache(cacheKey) {
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;
    try {
        return normalizeWordsData(JSON.parse(Base64.decode(cached)), cacheKey);
    } catch (error) {
        console.warn(`${cacheKey} cache is invalid and will be rebuilt`, error);
        localStorage.removeItem(cacheKey);
        return null;
    }
}

function writeWordCache(cacheKey, wordsData) {
    try {
        localStorage.setItem(cacheKey, Base64.encode(JSON.stringify(wordsData)));
        return true;
    } catch (error) {
        // The in-memory dictionary remains usable even if WebView storage is full.
        console.warn(`${cacheKey} cache could not be saved`, error);
        return false;
    }
}
// 后端请求教材数据
function getNewWords(){
    const params = new URLSearchParams();
    params.append('method', 'getAll');
    return axios.post('words/', params).then(ret => normalizeWordsData(ret.data, 'newWords'));
}

// 请求3500
function getWords3500(){
    const params = new URLSearchParams();
    params.append('method', 'post');
    return axios.post('words3500/', params).then(ret => normalizeWordsData(ret.data, 'words3500'));
}

// Native installs must be useful before the first network request succeeds.
// These snapshots are refreshed when a new APK is built and can later be updated
// from the server through the existing update controls.
function getInitialNewWords(){
    return normalizeWordsData(bundledNewWords, 'bundled newWords');
}

function getInitialWords3500(){
    return normalizeWordsData(bundledWords3500, 'bundled words3500');
}

// 合并俩种单词
function mergeAllWords(gaokaoWords, textWords){
    let mergeWords = [];
    // console.log('gaokaoWords', gaokaoWords);
    // console.log('textWords', textWords);
    for(let i =0; i < gaokaoWords.length; i++){
        for(let j =0; j < textWords.length; j++){
            if(gaokaoWords[i].英文 == textWords[j].英文){
                mergeWords.push({
                    '英文': gaokaoWords[i].英文,
                    '3500中文': gaokaoWords[i].中文,
                    '教材中文': textWords[j].中文,
                    '教材': textWords[j].教材,
                    '模块': textWords[j].模块,
                    '备注': textWords[j].备注,
                    '词性': gaokaoWords[i].词性,
                })
            }else{
                mergeWords.push(gaokaoWords[i])
                mergeWords.push(textWords[j])
            }
        }
    }
    console.log(mergeWords)
}

// 得到日期
function getDate(strDate) {
    let st = strDate;
    let a = st.split(" ");
    let b = a[0].split("-");
    let c = a[1].split(":");
    let date = new Date(b[0], b[1]-1, b[2], c[0], c[1], c[2]);
    return date;
};
// 接受数组data（内部是对象），按照p排序
function ForwardRankingData(data, p) {
    // p要求为指定顺序
    const books = p[0];
    const modules = p[1];
    let temp
    for (let i = 0; i < data.length - 1; i++) {
        for (let j = 0; j < data.length - 1 - i; j++) {
            if (books.indexOf(data[j]['教材']) > books.indexOf(data[j+1]['教材'])) {
                temp = data[j];
                data[j] = data[j + 1];
                data[j + 1] = temp;
            }
            if (books.indexOf(data[j]['教材']) == books.indexOf(data[j+1]['教材']) && modules.indexOf(data[j]['模块']) > modules.indexOf(data[j+1]['模块'])) {
                temp = data[j];
                data[j] = data[j + 1];
                data[j + 1] = temp;
            }
        }
    }
    return data;
}
// 去除收尾空格
function trimStr(str){
    return str.replace(/(^\s*)|(\s*$)/g,"");
}
export default {
    getWords3500,
    getNewWords,
    getInitialWords3500,
    getInitialNewWords,
    readWordCache,
    writeWordCache,
    getDate,
    ForwardRankingData,
    trimStr,
    mergeAllWords
}
